import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-budget',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class BudgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/system/budget/budget.component.ts